export default __webpack_public_path__ + "68ed354886ebb66bfbf870687512b02f.png";